import memoize from 'lodash/memoize'
// @ts-ignore
import { Token } from '@pancakeswap/sdk'
import { ChainId } from '@pancakeswap/chains'
import { safeGetAddress } from 'utils'
import { isAddress } from 'viem'

const mapping = {
  [ChainId.PULSE]: 'pulse',
}

export const getTokenLogoURL = (token?: Token) => {
  let symbol = token.symbol?.toLowerCase()
  if (token?.address?.toLowerCase() === "0xdAC17F958D2ee523a2206206994597C13D831ec7".toLowerCase()) { // pUSDT
    symbol = 'pusdt'
  }
  if (token?.address?.toLowerCase() === "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48".toLowerCase()) { // pUSDC
    symbol = 'pusdc'
  }
  if (token?.address?.toLowerCase() === "0x6B175474E89094C44Da98b954EedeAC495271d0F".toLowerCase()) { // pDAI
    symbol = 'pdai'
  }
  if (symbol === 'pstable lp') {
    return 'https://pdex.vision/images/369/symbols/pstable%20lp.png'
  }
  if (symbol) return `https://pdex.vision/assets/symbols/${symbol}.png`
  return null
}

export const getTokenLogoURLWithSymbol = (tokenSymbol?: string) => {
  if (tokenSymbol === 'pstable lp') {
    return 'https://pdex.vision/images/369/symbols/pstable%20lp.png'
  }
  if (tokenSymbol) return `https://pdex.vision/assets/symbols/${tokenSymbol}.png`
  return null
}

export const getTokenLogoURLByAddress = memoize(
  (address?: string, chainId?: number) => {
    if (address && chainId && mapping[chainId] && isAddress(address)) {
      return `https://pdex.vision/assets/tokens/${address}.png`
    }
    return null
  },
  (address, chainId) => `${chainId}#${address}`,
)

export default getTokenLogoURL
